<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <el-card style="margin-top: 20px">
          <div slot="header" class="clearfix">
            <span>密码重置</span>
          </div>

          <el-form
            ref="form"
            :rules="rules"
            :model="resetParams"
            label-width="150px"
            style="max-width: 600px; margin: 30px auto"
          >
            <el-form-item label="请输入管理员ID" prop="admin_id">
              <el-input
                v-model="resetParams.admin_id"
                placeholder="请输入管理员ID"
                clearable
              />
            </el-form-item>

            <el-form-item label="请输入新密码" prop="password">
              <el-input
                v-model="resetParams.password"
                type="password"
                placeholder="请输入新密码"
                clearable
              />
            </el-form-item>

            <el-form-item label="请再次输入新密码" prop="re_password">
              <el-input
                v-model="resetParams.re_password"
                type="password"
                placeholder="请再次输入新密码"
                clearable
              />
            </el-form-item>

            <el-form-item style="text-align: center; margin-top: 20px">
              <el-button type="primary" @click="reset('form')">
                保 存
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-pwd-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <el-card style="margin: 10px">
          <div slot="header">密码重置</div>

          <el-form
            ref="form"
            :rules="rules"
            :model="resetParams"
            label-width="110px"
            style="padding: 10px 0"
          >
            <el-form-item label="管理员ID" prop="admin_id">
              <el-input
                v-model="resetParams.admin_id"
                placeholder="请输入管理员ID"
                size="medium"
                clearable
              />
            </el-form-item>

            <el-form-item label="新密码" prop="password">
              <el-input
                v-model="resetParams.password"
                type="password"
                placeholder="请输入新密码"
                size="medium"
                clearable
              />
            </el-form-item>

            <el-form-item label="确认新密码" prop="re_password">
              <el-input
                v-model="resetParams.re_password"
                type="password"
                placeholder="请再次输入新密码"
                size="medium"
                clearable
              />
            </el-form-item>

            <el-form-item style="text-align: center; margin-top: 15px">
              <el-button
                type="primary"
                size="medium"
                round
                @click="reset('form')"
              >
                确认保存
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/api.js";
export default {
  name: "Password",
  data() {
    return {
      loading: false,
      resetParams: {
        admin_id: "",
        password: "",
        re_password: "",
      },
      rules: {
        admin_id: [
          { required: true, message: "请输入管理员ID", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, message: "密码至少输入6位", trigger: "blur" },
          { max: 20, message: "密码最多输入20位", trigger: "blur" },
        ],
        re_password: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          { min: 6, message: "确认密码至少输入6位", trigger: "blur" },
          { max: 20, message: "确认密码最多输入20位", trigger: "blur" },
          { validator: this.checkPassword, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 两次密码一致验证
    checkPassword(rule, value, callback) {
      if (value !== this.resetParams.password) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    },
    reset(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          api.admin
            .password(this.resetParams)
            .then((res) => {
              if (res.data.code == 200 || res.data.code == 1000) {
                this.init();
              } else {
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    init() {
      this.resetParams = {
        admin_id: "",
        password: "",
        re_password: "",
      };
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/pages/admin/password.vue